import Translations from '../Translations';
import React, {} from 'react';
import {
    Card,
    Header,
    Icon,
} from 'semantic-ui-react';
import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import {hideZeroPrice} from '../../utils/abbth';
import {formatAmountWithCurrency} from '../../utils/currency';

const ProductOption = (props) => {

    const {
        selectedOption,
        handleUpdateSelectedOption,
        productType,
        currencyMinorUnit,
        currency,
        productKey,
    } = props;

    const {
        id,
        // option,
        name,
        // description,
        isRequiredHdf,
        // order,
        // plan,
        price,
        sumAssured,
    } = props.option;

    const isSelected = (selectedOption === id) ? true : false;

    const isDeduct = (price >= 0) ? true : false;

    const priceSign = (price > 0) ? '-' : (price < 0) ? '+' : '';

    return (
        <Card
            onClick={() => handleUpdateSelectedOption(id)}
            fluid
            style={{
                border: (isSelected) ? "2px solid #3F8CFF" : "1px solid #E5E5E5",
                borderRadius: "10px",
            }}
        >
            <Card.Content>
                <Header as="h5" className="selection-option-heading">
                    <span className="selection-option-name">{name}</span>
                    {!hideZeroPrice(productKey, price) && <div className="selection-option-price">
                        {formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas(isDeduct ? price : price * -1, currencyMinorUnit), currency, priceSign)}
                        {/* <Icon 
                            color={(isDeduct) ? "red" : "blue"}
                            name={(isDeduct) ? "minus circle" : "add circle"}
                            style={{marginLeft: 5}}
                        /> */}
                    </div>}
                </Header>
                {(isRequiredHdf) && (
                    <div style={{float: "right", color: "#808191", fontSize: "12px"}}><Translations text="selection.hdf_noti_tooltip1" backup={"HDF Required"} /><Icon name="flag" color="red"/>
                    </div>
                )}
                {(sumAssured > 0) && (
                    <p style={{color: "#808191", fontSize: "12px"}}>
                        <Translations text="selection.sumassured" backup={"Sum Assured"} />: {formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas(sumAssured), currency)}
                    </p>
                )}
            </Card.Content>
        </Card>
    );
};

export default ProductOption;
